import { Box, Stack, Inline, Text, Icons } from "@sembark-travel/ui-base"

import { useItineraryLoaderEngine } from "./useItineraryLoaderEngine"
import * as s from "./ItineraryLoader.css"
import { ItineraryLoaderProps } from "./Types"
import {
	ButtonLink,
	NavigationPromptDialog,
	useNavigationPrompt,
} from "@sembark-travel/ui-router"
import { generatePath } from "../../router-utils"

export function ItineraryLoader({
	className,
	status = "pending",
	tripId,
}: ItineraryLoaderProps) {
	const { blocker } = useNavigationPrompt(true)
	const { stage, canvas, live } = useItineraryLoaderEngine({
		loading: !!status,
		direction: "outward",
	})

	if (status === "failed") {
		return (
			<Box className={`${s.overlay} ${className ?? ""}`}>
				<Stack
					gap={"1"}
					backgroundColor={"default"}
					padding={"4"}
					rounded="lg"
					alignItems="center"
				>
					<Text color="muted" fontWeight="semibold" fontSize={"xl"}>
						Something went wrong
					</Text>
					<Text color="muted">
						We couldn't process your details. Please try again.
					</Text>
					<ButtonLink to={generatePath("/trips/:tripId", { tripId: tripId })}>
						Upload Again
					</ButtonLink>
				</Stack>
			</Box>
		)
	}

	return (
		<Box className={`${s.overlay} ${className ?? ""}`}>
			{status && (
				<Stack alignItems="center">
					<Box
						position="relative"
						style={{ width: "min(42vmin, 340px)", aspectRatio: 1 }}
						ref={stage}
					>
						<canvas className={s.canvasEl} ref={canvas} />
						<Box className={s.logoWrap}>
							<Icons.DarkLogo width={"8"} height={"8"} />
						</Box>
					</Box>

					<Inline
						className={s.headline}
						alignItems="center"
						justifyContent="center"
					>
						<span className={s.pulse} />
						<span className={s.liveTxt} ref={live} aria-live="polite" />
					</Inline>
				</Stack>
			)}
			{/*Accidental Back Navigation Prevention Dialog*/}
			<NavigationPromptDialog blocker={blocker} />
		</Box>
	)
}
export default ItineraryLoader
